import { ReactNode } from 'react';
import { WbAlert } from '@agilelab/plugin-wb-platform';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface ProcessingDialogProps {
  open: boolean;
  onClose?: () => void;
  children?: ReactNode;
  submitButton?: ReactNode;
  onBack: () => void;
  isError?: boolean;
  isSuccess?: boolean;
}
export const ProcessingDialog = ({
  open,
  onClose,
  children,
  submitButton,
  onBack,
  isError,
  isSuccess,
}: ProcessingDialogProps) => {
  const theme = useTheme();

  const outcomeMessage = (
    <WbAlert
      message={{
        title: isError ? 'An error occurred.' : 'Success.',
        content: isError
          ? 'Processing failed due to an error.'
          : 'No errors were found.',
        type: isError ? 'error' : 'success',
      }}
    />
  );

  return (
    <Dialog
      maxWidth="xl"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 1,
          backgroundColor: theme.palette.background.default,
        },
      }}
      open={open}
      onClose={
        onClose
          ? () => {
              onBack();
              onClose();
            }
          : undefined
      }
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <DialogTitle>
        <Typography>Processing</Typography>

        {onClose && (
          <IconButton
            size="small"
            aria-label="close"
            onClick={() => {
              onBack();
              onClose();
            }}
            style={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>
      <DialogContent dividers>
        {(isError || isSuccess) && outcomeMessage}
        <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 15 }}>
          {children}
        </Box>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          {submitButton}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
